import { render, staticRenderFns } from "./related-object.vue?vue&type=template&id=442b6b6a&scoped=true&"
import script from "./related-object.vue?vue&type=script&lang=js&"
export * from "./related-object.vue?vue&type=script&lang=js&"
import style0 from "./related-object.vue?vue&type=style&index=0&id=442b6b6a&prod&scoped=true&lang=scss&"
import style1 from "./related-object.vue?vue&type=style&index=1&id=442b6b6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b6b6a",
  null
  
)

export default component.exports